<div class="study-viewer-loader">
  <div class="study-viewer-loader__label">
    Loading: {{ loadingStateLabel() }}
  </div>
</div>
